import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../utils/api";
import { useTheme } from "../../contexts/ThemeContext";
import { useThemeClasses } from "../../hooks/useThemeClasses";
import { useCart } from "../../contexts/CartContext";
import { authService } from "../../services/apiService";

const TOP_PROMO_STRIP = [
  "FREE DELIVERY ABOVE ₹999",
  "USED PARTS AT 40-60% LESS — QUALITY CHECKED",
  "USE CODE SPARE20 FOR EXTRA 20% OFF",
  "FLASH DEALS END IN A FEW HOURS",
  "100% GENUINE PARTS",
];

const DEAL_FILTERS = [
  { id: "all", label: "All Deals", icon: "🔥" },
  { id: "flash", label: "Flash Sale", icon: "⚡" },
  { id: "combo", label: "Combos", icon: "📦" },
  { id: "clearance", label: "Clearance", icon: "🏷️" },
  { id: "brand", label: "Brand Offers", icon: "🏢" },
];

const DEAL_ITEMS = [
  {
    id: 1,
    type: "flash",
    brand: "CASTROL",
    title: "Castrol EDGE 5W-30 4L",
    discountPct: 48,
    price: 2599,
    mrp: 4999,
    badge: "FLASH",
    image: "🛢️",
    gradient: "from-blue-950/80 to-blue-900/40",
    rating: 4.8,
    sold: 342,
    stockLeft: 50,
    stockTotal: 120,
  },
  {
    id: 2,
    type: "flash",
    brand: "BOSCH",
    title: "Bosch Spark Plug Set (4pc)",
    discountPct: 46,
    price: 899,
    mrp: 1659,
    badge: "FLASH",
    image: "⚡",
    gradient: "from-slate-950 to-slate-900/70",
    rating: 4.9,
    sold: 188,
    stockLeft: 28,
    stockTotal: 90,
  },
  {
    id: 3,
    type: "flash",
    brand: "BREMBO",
    title: "Brembo Brake Pad Set Front",
    discountPct: 48,
    price: 3249,
    mrp: 6250,
    badge: "FLASH",
    image: "🛑",
    gradient: "from-red-950/80 to-red-900/50",
    rating: 4.7,
    sold: 89,
    stockLeft: 15,
    stockTotal: 60,
  },
  {
    id: 4,
    type: "combo",
    brand: "VALEO",
    title: "Clutch Kit + Release Bearing Combo",
    discountPct: 35,
    price: 5699,
    mrp: 8799,
    badge: "COMBO",
    image: "⚙️",
    gradient: "from-emerald-950/80 to-emerald-900/50",
    rating: 4.6,
    sold: 120,
    stockLeft: 34,
    stockTotal: 100,
  },
  {
    id: 5,
    type: "clearance",
    brand: "SHELL",
    title: "Shell Helix Ultra 5W-40",
    discountPct: 31,
    price: 1999,
    mrp: 2899,
    badge: "CLEARANCE",
    image: "🧴",
    gradient: "from-amber-950/80 to-amber-900/50",
    rating: 4.5,
    sold: 76,
    stockLeft: 19,
    stockTotal: 80,
  },
  {
    id: 6,
    type: "brand",
    brand: "MANN FILTER",
    title: "Air + Cabin Filter Pack",
    discountPct: 28,
    price: 1449,
    mrp: 2019,
    badge: "BRAND DEAL",
    image: "🧰",
    gradient: "from-indigo-950/80 to-indigo-900/50",
    rating: 4.7,
    sold: 214,
    stockLeft: 41,
    stockTotal: 130,
  },
  {
    id: 7,
    type: "brand",
    brand: "DENSO",
    title: "Denso AC Compressor",
    discountPct: 38,
    price: 8999,
    mrp: 14500,
    badge: "BRAND",
    image: "❄️",
    gradient: "from-blue-950/80 to-blue-900/50",
    rating: 4.8,
    sold: 54,
    stockLeft: 22,
    stockTotal: 90,
  },
  {
    id: 8,
    type: "clearance",
    brand: "MRF",
    title: "MRF ZVTV 185/65 R15",
    discountPct: 33,
    price: 3499,
    mrp: 5200,
    badge: "CLEARANCE",
    image: "🛞",
    gradient: "from-amber-950/80 to-amber-900/50",
    rating: 4.6,
    sold: 210,
    stockLeft: 45,
    stockTotal: 120,
  },
  {
    id: 9,
    type: "flash",
    brand: "MAHLE",
    title: "Mahle Air Filter Honda City",
    discountPct: 48,
    price: 299,
    mrp: 580,
    badge: "FLASH",
    image: "🔧",
    gradient: "from-emerald-950/80 to-emerald-900/50",
    rating: 4.5,
    sold: 567,
    stockLeft: 80,
    stockTotal: 170,
  },
  {
    id: 10,
    type: "clearance",
    brand: "MONROE",
    title: "Monroe Shock Front Pair",
    discountPct: 43,
    price: 3899,
    mrp: 6800,
    badge: "CLEARANCE",
    image: "🦴",
    gradient: "from-orange-950/80 to-red-900/50",
    rating: 4.4,
    sold: 78,
    stockLeft: 34,
    stockTotal: 100,
  },
  {
    id: 11,
    type: "flash",
    brand: "SHELL",
    title: "Shell Helix Ultra 5W-40 4L",
    discountPct: 43,
    price: 1599,
    mrp: 2800,
    badge: "FLASH",
    image: "🛢️",
    gradient: "from-lime-950/80 to-lime-900/40",
    rating: 4.7,
    sold: 445,
    stockLeft: 66,
    stockTotal: 150,
  },
  {
    id: 12,
    type: "clearance",
    brand: "VALEO",
    title: "Valeo Wiper Blade Set",
    discountPct: 45,
    price: 499,
    mrp: 900,
    badge: "CLEARANCE",
    image: "🚗",
    gradient: "from-indigo-950/80 to-violet-900/50",
    rating: 4.3,
    sold: 234,
    stockLeft: 52,
    stockTotal: 140,
  },
];

const SMART_COMBOS = [
  {
    id: 1,
    title: "Complete Service Kit — Maruti Swift",
    includes: "Engine oil + Oil filter + Air filter + Spark plugs",
    price: 2199,
    mrp: 3800,
    save: 1801,
    icons: ["🛢️", "🔧", "⚡"],
  },
  {
    id: 2,
    title: "Brake Overhaul Kit — Universal",
    includes: "Front + Rear pads + Brake fluid + Cleaner",
    price: 4599,
    mrp: 7400,
    save: 2801,
    icons: ["🛑", "🔧", "🛢️"],
  },
  {
    id: 3,
    title: "Monsoon Ready Pack",
    includes: "Wipers + Headlight bulbs + Tyre sealant",
    price: 1299,
    mrp: 2100,
    save: 801,
    icons: ["🚗", "💡", "🛞"],
  },
  {
    id: 4,
    title: "AC Service Combo",
    includes: "AC gas + Cabin filter + Vent cleaner",
    price: 3499,
    mrp: 5200,
    save: 1701,
    icons: ["❄️", "🧰", "🧴"],
  },
];

const ACTIVE_COUPONS = [
  {
    id: 1,
    code: "SPARE20",
    desc: "Flat 20% off on orders above ₹2,000",
    expiry: "Expires: Apr 30, 2026",
    icon: "🪙",
    accent: "from-rose-500 to-orange-400",
  },
  {
    id: 2,
    code: "FIRST500",
    desc: "₹500 off on your first order",
    expiry: "Expires: May 15, 2026",
    icon: "🎉",
    accent: "from-emerald-500 to-cyan-400",
  },
  {
    id: 3,
    code: "FREESHIP",
    desc: "Free shipping on all orders",
    expiry: "Expires: Apr 25, 2026",
    icon: "🚚",
    accent: "from-indigo-500 to-violet-400",
  },
  {
    id: 4,
    code: "OIL15",
    desc: "15% off on all engine oils",
    expiry: "Expires: May 1, 2026",
    icon: "🛢️",
    accent: "from-pink-500 to-rose-400",
  },
];

const INITIAL_COUNTDOWN_SECONDS = 7 * 60 * 60 + 46 * 60 + 45;
const DEAL_GRADIENTS = [
  "from-blue-950/80 to-blue-900/40",
  "from-slate-950 to-slate-900/70",
  "from-red-950/80 to-red-900/50",
  "from-emerald-950/80 to-emerald-900/50",
  "from-amber-950/80 to-amber-900/50",
  "from-indigo-950/80 to-indigo-900/50",
];
const DEAL_EMOJIS = ["🛢️", "⚡", "🛑", "⚙️", "🧴", "🛞", "🔧", "❄️"];

const toTwoDigits = (num) => String(Math.max(0, num)).padStart(2, "0");

const normalizeRole = (role) => {
  const r = String(role || "").toLowerCase();
  if (r === "buyer") return "customer";
  if (r === "new seller") return "vendor";
  if (r === "used seller") return "used_vendor";
  if (r === "mechanic") return "mechanics";
  if (r === "garages") return "garage";
  return r;
};

const pickDealType = (category) => {
  const c = String(category || "").toLowerCase();
  if (["flash", "combo", "clearance", "brand"].includes(c)) return c;
  return "brand";
};

const Offers = () => {
  const navigate = useNavigate();
  const { isDark } = useTheme();
  const { sc } = useThemeClasses();
  const { addToCart } = useCart();
  const [activeFilter, setActiveFilter] = useState("all");
  const [remainingSeconds, setRemainingSeconds] = useState(
    INITIAL_COUNTDOWN_SECONDS
  );
  const [liveDeals, setLiveDeals] = useState([]);
  const [dealsLoading, setDealsLoading] = useState(false);
  const [dealsError, setDealsError] = useState("");
  const [addingDealId, setAddingDealId] = useState(null);
  const stockStreamsRef = useRef({});

  useEffect(() => {
    const loadDeals = async () => {
      setDealsLoading(true);
      setDealsError("");
      try {
        const res = await api.get("/public/deals");
        const list = res.data?.data?.deals || res.data?.deals || [];
        if (!Array.isArray(list) || list.length === 0) {
          setLiveDeals([]);
          return;
        }
        const mapped = list.map((d, idx) => {
          const type = pickDealType(d?.category);
          const title = d?.title || d?.productName || "Untitled deal";
          const discountPct = Math.max(0, Number(d?.discountPct || 0));
          const price = Number(d?.dealPrice ?? d?.productPrice ?? 0);
          const mrp = Number(d?.lockedBasePrice ?? d?.productPrice ?? price);
          const stockTotal = Math.max(0, Number(d?.poolUnits || 0));
          const stockLeft = Math.max(0, Number(d?.poolRemainingUnits || 0));
          const productId = d?.productId || d?.product?._id || null;
          const endTs = d?.endDate ? new Date(d.endDate).getTime() : null;
          return {
            id: d?._id || d?.id || `deal-${idx}`,
            dealId: String(d?._id || d?.id || ""),
            productId: productId ? String(productId) : null,
            type,
            brand: String(d?.productName || title).split(" ")[0].toUpperCase(),
            title,
            discountPct,
            price: Number.isFinite(price) ? price : 0,
            mrp: Number.isFinite(mrp) && mrp > 0 ? mrp : Math.max(1, Number(price) || 1),
            badge: String(type).toUpperCase().replace(/_/g, " "),
            image: DEAL_EMOJIS[idx % DEAL_EMOJIS.length],
            gradient: DEAL_GRADIENTS[idx % DEAL_GRADIENTS.length],
            rating: 4.6,
            sold: Math.max(0, Number(d?.soldCount) || 0),
            stockLeft,
            stockTotal: Math.max(stockTotal, stockLeft || 0, 1),
            endDate: d?.endDate || null,
            endTs,
            socialProof: d?.socialProof || null,
            productName: d?.productName || "",
          };
        });
        setLiveDeals(mapped);
      } catch (e) {
        setLiveDeals([]);
        setDealsError("Failed to load offers from backend");
      } finally {
        setDealsLoading(false);
      }
    };
    loadDeals();
  }, []);

  const dealsSource = liveDeals;

  const filteredDeals = useMemo(() => {
    if (activeFilter === "all") return dealsSource;
    return dealsSource.filter((item) => item.type === activeFilter);
  }, [activeFilter, dealsSource]);

  useEffect(() => {
    const nearestEnd = liveDeals
      .filter((d) => d.type === "flash" && d.endTs)
      .map((d) => d.endTs)
      .sort((a, b) => a - b)[0];
    if (!nearestEnd) return undefined;
    const tick = setInterval(() => {
      const sec = Math.max(0, Math.floor((nearestEnd - Date.now()) / 1000));
      setRemainingSeconds(sec > 0 ? sec : 0);
    }, 1000);
    return () => clearInterval(tick);
  }, [liveDeals]);

  const applyStockPatch = useCallback((dealId, patch) => {
    if (!dealId || !patch) return;
    setLiveDeals((prev) =>
      prev.map((d) => {
        if (String(d.dealId || d.id) !== String(dealId)) return d;
        const stockLeft = Math.max(0, Number(patch.poolRemainingUnits ?? d.stockLeft));
        const stockTotal = Math.max(stockLeft, Number(patch.poolUnits ?? d.stockTotal));
        return {
          ...d,
          stockLeft,
          stockTotal,
          sold: Math.max(0, Number(patch.soldCount ?? d.sold)),
          socialProof: patch.socialProof || d.socialProof,
        };
      })
    );
  }, []);

  useEffect(() => {
    const flashIds = liveDeals
      .filter((d) => d.type === "flash" && d.dealId)
      .map((d) => d.dealId);
    const base = api.defaults?.baseURL || "http://localhost:5000/api";

    flashIds.forEach((dealId) => {
      if (stockStreamsRef.current[dealId]) return;
      const url = `${base.replace(/\/$/, "")}/public/deals/${dealId}/stock-stream`;
      const es = new EventSource(url);
      es.onmessage = (ev) => {
        try {
          const data = JSON.parse(ev.data);
          applyStockPatch(dealId, data);
        } catch (_) {
          /* ignore */
        }
      };
      stockStreamsRef.current[dealId] = es;
    });

    return () => {
      Object.values(stockStreamsRef.current).forEach((es) => es.close());
      stockStreamsRef.current = {};
    };
  }, [liveDeals, applyStockPatch]);

  const handleAddDealToCart = async (deal) => {
    if (!deal?.productId || !deal?.dealId) {
      toast.error("This offer is not linked to a product yet.");
      return;
    }
    if (!authService.isAuthenticated()) {
      localStorage.setItem(
        "pendingCartProduct",
        JSON.stringify({
          id: deal.productId,
          _id: deal.productId,
          dealId: deal.dealId,
          name: deal.title,
          brand: deal.brand,
          price: deal.mrp,
          discountPrice: deal.price,
          quantity: 1,
        })
      );
      navigate("/login?redirect=cart");
      return;
    }
    setAddingDealId(deal.dealId);
    try {
      await addToCart(
        {
          id: deal.productId,
          _id: deal.productId,
          dealId: deal.dealId,
          name: deal.title || deal.productName || "Deal product",
          brand: deal.brand || "",
          price: deal.mrp,
          discountPrice: deal.price,
          quantity: 1,
        },
        false
      );
      toast.success("Added to cart — complete checkout before your reservation expires.");
      navigate("/cart");
    } catch (e) {
      toast.error(e?.response?.data?.message || e?.message || "Could not add deal to cart");
    } finally {
      setAddingDealId(null);
    }
  };

  const timer = useMemo(() => {
    const hours = Math.floor(remainingSeconds / 3600);
    const minutes = Math.floor((remainingSeconds % 3600) / 60);
    const seconds = remainingSeconds % 60;
    return {
      hours: toTwoDigits(hours),
      minutes: toTwoDigits(minutes),
      seconds: toTwoDigits(seconds),
    };
  }, [remainingSeconds]);

  const pageShell = isDark
    ? "min-h-screen bg-sparepe-deep text-sparepe-ink"
    : "min-h-screen bg-slate-50 text-slate-900";
  const promoStrip = isDark
    ? "bg-sparepe-surface border-b border-sparepe-border text-[10px] sm:text-xs font-semibold text-sparepe-accent-dk"
    : "bg-amber-50 border-b border-amber-200 text-[10px] sm:text-xs font-bold text-amber-900";
  const heroSection = isDark
    ? "relative rounded-sparepe-xl overflow-hidden border border-sparepe-border-md bg-gradient-to-br from-primary-800 via-primary-600 to-primary-500 px-5 sm:px-8 py-6 sm:py-8 mb-6 shadow-sp-premium"
    : "relative rounded-3xl overflow-hidden border border-amber-200 bg-gradient-to-br from-amber-500 via-orange-500 to-orange-400 px-5 sm:px-8 py-6 sm:py-8 mb-6 shadow-xl";
  const filterIdle = isDark
    ? "inline-flex items-center gap-2 rounded-full border border-sparepe-border bg-sparepe-card px-4 py-2 text-xs sm:text-sm font-semibold text-sparepe-ink-2 hover:border-sparepe-accent hover:text-sparepe-accent-dk"
    : "inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-4 py-2 text-xs sm:text-sm font-semibold text-slate-600 hover:border-amber-400 hover:text-amber-800";
  const filterActive = isDark
    ? "inline-flex items-center gap-2 rounded-full border border-sparepe-accent bg-sparepe-accent-lt px-4 py-2 text-xs sm:text-sm font-bold text-sparepe-accent-dk shadow-sp-glow"
    : "inline-flex items-center gap-2 rounded-full border border-amber-400 bg-gradient-to-r from-amber-500 to-orange-500 px-4 py-2 text-xs sm:text-sm font-bold text-white shadow-md";
  const sectionTitle = isDark ? "text-2xl sm:text-3xl font-bold text-sparepe-ink tracking-tight" : "text-2xl sm:text-3xl font-black text-slate-900 tracking-tight";
  const dealCard = isDark
    ? "rounded-sparepe-lg overflow-hidden border border-sparepe-border bg-sparepe-card hover:border-sparepe-border-md transition-all duration-200 hover:shadow-sp-glow"
    : "rounded-2xl overflow-hidden border border-slate-200 bg-white hover:border-amber-300 transition-colors shadow-sm";
  const comboCard = sc("comboCard");
  const couponCard = sc("couponCard");

  return (
    <div className={pageShell}>
      <div className={promoStrip}>
        <div className="max-w-7xl mx-auto px-2 sm:px-4 py-1.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
          {TOP_PROMO_STRIP.map((item) => (
            <span key={item} className="tracking-wide uppercase">
              {item}
            </span>
          ))}
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-3 sm:px-5 md:px-8 py-5 sm:py-7">
        <section className={heroSection}>
          <div className="absolute -right-10 -top-12 w-48 h-48 sm:w-64 sm:h-64 rounded-full bg-white/10 blur-xl pointer-events-none" />
          <div className="absolute right-24 bottom-[-70px] w-40 h-40 rounded-full bg-black/10 pointer-events-none" />
          <div className="relative z-10">
            <h1 className="text-3xl sm:text-4xl font-black leading-tight text-white drop-shadow-sm">
              <span className="mr-2">🔥</span>
              Mega Auto Parts Sale
            </h1>
            <p className="text-white/90 text-sm sm:text-base mt-2 max-w-xl">
              Up to 60% off on genuine parts from top brands. Limited time only!
            </p>
            <div className="mt-5 flex items-center gap-2 sm:gap-3">
              {[
                { label: "HOURS", value: timer.hours },
                { label: "MINUTES", value: timer.minutes },
                { label: "SECONDS", value: timer.seconds },
              ].map((box) => (
                <div
                  key={box.label}
                  className="rounded-xl bg-black/20 border border-white/20 px-3 sm:px-4 py-2 text-center min-w-[64px]"
                >
                  <div className="text-2xl font-black leading-none text-white tabular-nums">
                    {box.value}
                  </div>
                  <div className="text-[9px] sm:text-[10px] text-white/80 tracking-wide mt-1">
                    {box.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="mb-5">
          <div className="flex flex-wrap gap-2">
            {DEAL_FILTERS.map((filter) => {
              const count =
                filter.id === "all"
                  ? dealsSource.length
                  : dealsSource.filter((item) => item.type === filter.id).length;
              const active = activeFilter === filter.id;
              return (
                <button
                  key={filter.id}
                  type="button"
                  onClick={() => setActiveFilter(filter.id)}
                  className={active ? filterActive : filterIdle}
                >
                  <span>{filter.icon}</span>
                  <span>{filter.label}</span>
                  <span className="rounded-full bg-black/20 px-1.5 py-0.5 text-[10px] tabular-nums">
                    {count}
                  </span>
                </button>
              );
            })}
          </div>
        </section>

        <section>
          <div className="flex items-center justify-between gap-3 mb-4">
            <h2 className={sectionTitle}>
              <span className={isDark ? "text-sparepe-accent mr-2" : "text-orange-500 mr-2"}>●</span>
              Flash Deals — Ends Soon
            </h2>
            <div className={`text-sm font-semibold ${isDark ? "text-sparepe-accent-dk" : "text-amber-700"}`}>
              {dealsLoading ? "Loading deals..." : "View All"}
            </div>
          </div>

          {dealsError && (
            <div className="mb-3 rounded-xl border border-red-400/40 bg-red-950/30 px-3 py-2 text-xs text-red-200">
              {dealsError}
            </div>
          )}

          {!dealsLoading && dealsSource.length === 0 && (
            <div className="rounded-xl border border-slate-700 bg-slate-900/60 px-4 py-6 text-sm text-slate-300 text-center">
              No live offers available right now.
            </div>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
            {filteredDeals.map((deal) => {
              const saveAmount = Math.max(0, deal.mrp - deal.price);
              const stockPercent = Math.max(
                6,
                Math.min(100, Math.round((deal.stockLeft / deal.stockTotal) * 100))
              );
              return (
                <article
                  key={deal.id}
                  className={dealCard}
                >
                  <div className={`h-36 bg-gradient-to-br ${deal.gradient} relative flex items-center justify-center`}>
                    <span className="absolute top-2 left-2 rounded-full bg-rose-500 px-2 py-1 text-[10px] font-black text-white">
                      {deal.badge}
                    </span>
                    <span className="absolute top-2 right-2 rounded-full bg-rose-500/90 px-2 py-1 text-[11px] font-black text-white">
                      -{deal.discountPct}%
                    </span>
                    <span className="text-5xl select-none">{deal.image}</span>
                  </div>

                  <div className="p-4">
                    <p className="text-[11px] uppercase tracking-wide text-blue-300 font-bold">
                      {deal.brand}
                    </p>
                    <h3 className="mt-1 text-base font-bold text-slate-100 leading-snug line-clamp-2 min-h-[2.6rem]">
                      {deal.title}
                    </h3>

                    <div className="mt-2.5 flex items-center gap-2 flex-wrap">
                      <span className="text-3xl font-black text-emerald-400 tabular-nums leading-none">
                        ₹{deal.price.toLocaleString("en-IN")}
                      </span>
                      <span className="text-sm text-slate-500 line-through tabular-nums">
                        ₹{deal.mrp.toLocaleString("en-IN")}
                      </span>
                      <span className="rounded-md bg-emerald-500/20 border border-emerald-500/30 px-1.5 py-0.5 text-[10px] font-bold text-emerald-300">
                        Save ₹{saveAmount.toLocaleString("en-IN")}
                      </span>
                    </div>

                    <div className="mt-2 flex items-center justify-between text-[11px]">
                      <span className="text-amber-300 font-semibold">⭐ {deal.rating.toFixed(1)}</span>
                      <span className="text-slate-500">{deal.sold} sold</span>
                    </div>

                    <div className="mt-2.5">
                      <div className="h-1.5 w-full rounded-full bg-slate-800 overflow-hidden">
                        <div
                          className="h-full rounded-full bg-gradient-to-r from-amber-400 via-orange-400 to-rose-500"
                          style={{ width: `${stockPercent}%` }}
                        />
                      </div>
                      <div className="mt-1 flex items-center justify-between text-[10px]">
                        <span className="text-slate-500">{deal.stockLeft} left</span>
                        <span className="text-rose-400">⚡ Hurry!</span>
                      </div>
                    </div>

                    <button
                      type="button"
                      disabled={!deal.productId || addingDealId === deal.dealId}
                      onClick={() => handleAddDealToCart(deal)}
                      className="mt-3.5 w-full sp-btn-gold disabled:opacity-50 disabled:cursor-not-allowed text-sm py-2.5"
                    >
                      {addingDealId === deal.dealId ? "Adding…" : "🛒 Add to Cart"}
                    </button>
                  </div>
                </article>
              );
            })}
          </div>
        </section>

        <section className="mt-10">
          <div className="flex items-center justify-between gap-3 mb-4">
            <h2 className={sectionTitle}>
              <span className="mr-2">📦</span>
              Smart Combos — Extra Savings
            </h2>
            <button
              type="button"
              className={`text-sm font-semibold ${isDark ? 'text-sky-300 hover:text-sky-200' : 'text-blue-600 hover:text-blue-700'}`}
            >
              See All →
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
            {SMART_COMBOS.map((combo) => (
              <article
                key={combo.id}
                className={comboCard}
              >
                <span className="inline-flex items-center rounded-full bg-emerald-500/15 border border-emerald-500/30 px-2 py-1 text-[10px] font-bold text-emerald-300">
                  💰 Save ₹{combo.save.toLocaleString("en-IN")}
                </span>

                <div className="mt-3 flex items-center gap-2 text-xl">
                  {combo.icons.map((icon, idx) => (
                    <React.Fragment key={`${combo.id}-${idx}`}>
                      <span className={`w-9 h-9 rounded-lg inline-flex items-center justify-center ${isDark ? 'bg-slate-800 border border-slate-700' : 'bg-slate-100 border border-slate-200'}`}>
                        {icon}
                      </span>
                      {idx < combo.icons.length - 1 ? (
                        <span className="text-slate-500 text-sm">+</span>
                      ) : null}
                    </React.Fragment>
                  ))}
                </div>

                <h3 className={`mt-3 text-base font-bold leading-snug ${isDark ? 'text-slate-100' : 'text-slate-900'}`}>
                  {combo.title}
                </h3>
                <p className={`mt-1 text-xs line-clamp-2 ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>
                  {combo.includes}
                </p>

                <div className="mt-3 flex items-end gap-2">
                  <span className="text-3xl font-black text-emerald-400 leading-none tabular-nums">
                    ₹{combo.price.toLocaleString("en-IN")}
                  </span>
                  <span className="text-sm text-slate-500 line-through tabular-nums">
                    ₹{combo.mrp.toLocaleString("en-IN")}
                  </span>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="mt-10">
          <h2 className={`${sectionTitle} mb-4`}>
            <span className="mr-2">🎟️</span>
            Active Coupons
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {ACTIVE_COUPONS.map((coupon) => (
              <article
                key={coupon.id}
                className={couponCard}
              >
                <div className={`absolute left-0 top-0 h-full w-1 bg-gradient-to-b ${coupon.accent}`} />
                <div className="flex items-center justify-between gap-3 pl-2">
                  <div className="flex items-center gap-3 min-w-0">
                    <span className={`w-9 h-9 shrink-0 rounded-lg inline-flex items-center justify-center text-lg ${isDark ? 'bg-slate-800 border border-slate-700' : 'bg-slate-100 border border-slate-200'}`}>
                      {coupon.icon}
                    </span>
                    <div className="min-w-0">
                      <p className={`text-sm font-black tracking-wide ${isDark ? 'text-white' : 'text-slate-900'}`}>{coupon.code}</p>
                      <p className={`text-xs ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>{coupon.desc}</p>
                      <p className={`text-[11px] mt-0.5 ${isDark ? 'text-slate-500' : 'text-slate-500'}`}>{coupon.expiry}</p>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="shrink-0 rounded-lg border border-indigo-400/40 bg-indigo-500/20 px-3 py-1.5 text-xs font-bold text-indigo-200 hover:bg-indigo-500/30 transition-colors"
                  >
                    Copy
                  </button>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="mt-8">
          <div className="rounded-2xl border border-slate-700 bg-[#121826] px-4 sm:px-5 py-3 flex flex-wrap items-center justify-center sm:justify-between gap-x-5 gap-y-2 text-xs sm:text-sm text-slate-300">
            <span>✅ 100% Genuine</span>
            <span>🔁 7-Day Returns</span>
            <span>🚚 Free Shipping 999+</span>
            <span>🔒 Secure Payments</span>
            <span>♻️ Used Parts Available</span>
          </div>
        </section>

        <section className="mt-6 mb-2">
          <div className="rounded-3xl border border-emerald-500/30 bg-gradient-to-r from-emerald-950/80 via-emerald-900/40 to-cyan-950/50 p-6 sm:p-8 flex items-center justify-between gap-4">
            <div className="flex items-start gap-4">
              <span className="text-4xl leading-none mt-1">♻️</span>
              <div>
                <h3 className="text-2xl sm:text-3xl font-black text-white">
                  Save 40-60% with Quality-Checked Used Parts
                </h3>
                <p className="mt-2 text-sm sm:text-base text-emerald-100/85 max-w-3xl">
                  Every used part goes through our 12-point quality check. Same fit, same function - at a fraction of the price. Sourced from verified scrapyards and dismantlers across India.
                </p>
                <button
                  type="button"
                  className="mt-4 rounded-xl bg-emerald-500 hover:bg-emerald-400 px-5 py-2.5 text-sm font-black text-emerald-950 transition-colors"
                >
                  Browse Used Parts →
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="mt-6 mb-6">
          <div className="rounded-3xl border border-indigo-400/20 bg-gradient-to-br from-[#141537] via-[#10132e] to-[#0d1024] p-6 sm:p-10 text-center">
            <h3 className="text-3xl sm:text-4xl font-black text-white tracking-tight">
              <span className="mr-2">📩</span>
              Get Deal Alerts — Never Miss a Sale
            </h3>
            <p className="mt-2 text-slate-300 text-sm sm:text-base">
              Subscribe and get flash deal notifications before anyone else. Early access = best prices.
            </p>
            <div className="mt-5 max-w-xl mx-auto flex flex-col sm:flex-row items-stretch gap-2">
              <input
                type="text"
                placeholder="Enter your email or WhatsApp number"
                className="flex-1 rounded-xl border border-slate-700 bg-slate-900/80 px-4 py-3 text-sm text-slate-100 placeholder:text-slate-500 outline-none focus:border-indigo-400"
              />
              <button
                type="button"
                className="rounded-xl bg-indigo-500 hover:bg-indigo-400 px-5 py-3 text-sm font-black text-white transition-colors"
              >
                Subscribe Free
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Offers;

